import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {RecipientStatus} from '@gatewee/types/recipient';

@Pipe({
  name: 'recipientStatus',
  standalone: false,
})
export class RecipientStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: RecipientStatus | string): string {
    const key = `enums.recipientStatus.${value}`;
    return (
      this.translate.instant(key) || this.translate.instant('common.unknown')
    );
  }
}
